"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SmiteAbilityHandler = exports.SmiteActorAbilityFactory = exports.SmiteAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Registries_1 = require("../../core/state/Registries");
const AbilityDamage_1 = require("../../core/AbilityDamage");
class SmiteAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.Smite;
        this.__typeName = "Smite";
    }
}
exports.SmiteAbilityArgs = SmiteAbilityArgs;
let SmiteActorAbilityFactory = class SmiteActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("Smite", "OneEnemies", 0);
    }
};
SmiteActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("Smite")
], SmiteActorAbilityFactory);
exports.SmiteActorAbilityFactory = SmiteActorAbilityFactory;
let SmiteAbilityHandler = class SmiteAbilityHandler {
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        const [selectedEnemy] = ability.args.target.actorIds;
        container.applyAttackWithDamage({
            sequence,
            abilityKey: ability.args.__typeName,
            attackType: "melee",
            attackerId: ability.invokerId,
            targetId: selectedEnemy,
            toApply: [
                AbilityDamage_1.AbilityDamage.Power("Physical", 80)
            ]
        });
    }
};
SmiteAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.Smite)
], SmiteAbilityHandler);
exports.SmiteAbilityHandler = SmiteAbilityHandler;
